<div class="warning-modal">
  <div class="container-fluid">
    <div class="text-container">
      <div class="text-container__img">
        <img src="../../../assets/images/icons/warning-icon.svg" />
      </div>
      <h1 class="title">{{ data.title | translate }}</h1>
      <div class="advise">
        <p>
          {{ data.text | translate }}
        </p>
      </div>
    </div>
    <div class="row footer">
      <button class="clsCardButton" (click)="closeModal(false)">
        {{ 'common.no' | translate }}
      </button>
      <button class="clsCardButton yes-button" (click)="closeModal(true)">
        {{ 'common.yes' | translate }}
      </button>
    </div>
  </div>
</div>
